import request from 'config/axios'

const getURL = year => `mufasa/reportIncome/${year}`

const configs = {
  responseType: 'arraybuffer'
}

export const getIncomeReport = ({ payload }) => request.get(getURL(payload), configs) // eslint-disable-line

export const postIncomeReport = ({ payload }) => request.post(getURL(payload), configs) // eslint-disable-line
